import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { __API_URL__ } from "../SERVER_URL";

const fetchArchiveStatus = async (trialId, taskId) => {
  const token = localStorage.getItem("token");
  const response = await axios.get(`${__API_URL__}/api/photos/trials/${trialId}/archive-status/`, {
    params: { task_id: taskId },
    headers: { Authorization: `Token ${token}` },
  });
  return response.data;
};

const useGetArchiveStatus = ({ trialId, taskId }) => {
  return useQuery({
    queryKey: ["archive-status", trialId, taskId],
    queryFn: () => fetchArchiveStatus(trialId, taskId),
    enabled: Boolean(trialId) && Boolean(taskId),
    refetchInterval: (query) => {
      const state = query.state.data?.state;
      if (state === "SUCCESS" || state === "FAILURE") return false;
      return 3000;
    },
  });
};

export default useGetArchiveStatus;
